import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Input,
  Modal,
  Select,
  Spin,
} from "antd";

import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import axios from "axios";
import { authenticateToken } from "../../../utils/auth";
import {
  getPage,
  getParamValue,
  checkStatesAndPushToHistory,
} from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation, useParams, useHistory } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";
import { PlusOutlined } from "@ant-design/icons";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import usePrevious from "../../../hooks/PreviousState";

const HubBrandList = (params): ReactElement => {
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setIsModalVisible(false);
  };
  const [brandOptions, setBrandOptions] = useState({
    loading: false,
    list: null,
  });
  const [brandData, setBrandData] = useState({
    loading: false,
    data: null,
  });
  const history = useHistory();
  const router = useLocation();
  // --------------------------------
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const shopId = shopInfo?.id;
  const route = useParams();

  // --------------------------------
  const [limit, setLimit] = useState(50);
  const [key, setKey] = useState(getParamValue(router?.search, "key"));
  const [brandId, setBrandId] = useState<any>();

  const shopID = (route as any)?.shopId;

  // **********************************
  // Search Options
  // **********************************
  const reseAllFieldData = () => {
    setKey("");
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };

  const getBrandOptions = useCallback(async (key) => {
    setBrandOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/brand-shop/by-shop?shopId=${shopID}` +
          (key ? `&key=${key}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setBrandOptions({
          loading: false,
          list: res.data?.brands?.map((brand: any) => ({
            label: brand.name,
            value: brand.id,
          })),
        });
      })
      .catch((err) => {
        setBrandOptions({ loading: false, list: [] });
        console.error("Categories: Error", err);
      });
  }, []);

  const fetchRef = useRef(0);
  const brandSearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getBrandOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getBrandOptions]);

  const getBrand = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberBrandList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberBrandList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey],
        [key],
        ["key"],
        history
      );
    }
    setBrandData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/brand-shop/by-shop?shopId=${shopID}` +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        // (status ? `&status=${status}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setBrandData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setBrandData({ loading: false, data: [] });
        console.error("Brand: Error", err);
      });
  }, [limit, page, key]);

  useEffect(() => {
    getBrand();
  }, [getBrand]);

  const previousKey = usePrevious(key);
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(localStorage.getItem("rememberBrandList"));
    if (retrievedObject.key) setKey(retrievedObject.key);
  }
  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      brands: data.brandId.map((brand: any, index: string) => ({
        brandId: brand,
        displayOrder:
          index +
          1 +
          (brandData?.data?.brands?.[brandData?.data?.brands?.length - 1]
            ?.displayOrder * 1 || 0),
      })),
      shopId: shopInfo?.id,
    };
    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/brand-shop`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          responseNotification("Brand Assigned Successfully", "success");
          //getBrand(shopInfo?.id);
          form.resetFields();
          handleOk();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  return (
    <React.Fragment>
      <ShopLayout shopId={shopId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Brand List"}
                rightarea={
                  <div className="">
                    {/* <Button
                      danger
                      type="primary"
                      icon={<PlusOutlined />}
                      title="Add Product"
                      onClick={showModal}
                    >
                      Add Brand
                    </Button> */}
                  </div>
                }
              />

              <section className="search_area">
                <Form form={form} className="search_form">
                  <Form.Item name="search" initialValue={key}>
                    <AutoComplete
                      onSearch={getBrandOptions}
                      onSelect={(val) => setKey(val.toString())}
                      options={brandOptions?.list}
                      defaultActiveFirstOption={false}
                      notFoundContent={
                        brandOptions?.loading ? <Spin size="small" /> : null
                      }
                      style={{ width: 300 }}
                    >
                      <Input.Search
                        size="large"
                        placeholder="Search by Name"
                        onSearch={(val) => setKey(val)}
                        enterButton
                        loading={brandOptions.loading}
                        maxLength={11}
                      />
                    </AutoComplete>
                  </Form.Item>
                </Form>
                <div className="search_btn">
                  <Button
                    type="primary"
                    danger
                    size="large"
                    onClick={reseAllFieldData}
                  >
                    Reset
                  </Button>
                </div>
              </section>
              <div className="product-list-item-area white-bg section-padding-bottom">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-list-items-inner-content">
                        <div className="single-product-wrapper">
                          <div className="single-product-heading">
                            <span>Brand ID</span>
                          </div>
                          <div className="single-product-heading">
                            <span>Brand Name</span>
                          </div>
                          <div className="single-product-heading">
                            <span>Brand Logo</span>
                          </div>
                          <div className="single-product-heading">
                            <span>Type</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {brandData?.loading ? (
                      <Loading />
                    ) : (
                      <div className="col-lg-12 product-table">
                        <div className="product-table-area">
                          {brandData?.data?.brands?.length ? (
                            brandData?.data?.brands?.map(
                              (brand: any, index: any) => (
                                <React.Fragment key={index}>
                                  {/* <Link to={`/users/${user?.id}`}> */}
                                  <div className="single-product-wrapper">
                                    <div className="single-product">
                                      <span className="name">{brand?.id}</span>
                                    </div>
                                    <div className="single-product">
                                      <span className="name">
                                        {brand?.name}
                                      </span>
                                    </div>
                                    <div className="single-product">
                                      <Avatar
                                        shape="square"
                                        size={45}
                                        src={brand?.logo}
                                        className="mr-3"
                                      />
                                    </div>
                                    <div className="single-product">
                                      <span className="name">
                                        {brand?.type?.split("_").join(" ")}
                                      </span>
                                    </div>
                                  </div>
                                  {/* </Link> */}
                                </React.Fragment>
                              )
                            )
                          ) : (
                            <Empty data="brands" />
                          )}
                        </div>
                      </div>
                    )}

                    <Modal
                      title="Assign Brand"
                      visible={isModalVisible}
                      onOk={handleOk}
                      onCancel={handleCancel}
                      footer={null}
                    >
                      <Form
                        name="control-hooks"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        className="ant-form ant-form-vertical"
                        onFinish={onSubmit}
                        form={form} // like ref
                        layout="vertical"
                        autoComplete="off"
                        initialValues={{
                          ...brandData,
                        }}
                      >
                        <Form.Item
                          hasFeedback
                          label="Select Brand"
                          name="brandId"
                          rules={[
                            {
                              required: true,
                              message: "Pleasse Select Minimum One Brand!",
                            },
                          ]}
                        >
                          <Select
                            disabled={!brandData?.data ? true : false}
                            allowClear
                            showSearch
                            placeholder="Search Brand"
                            optionFilterProp="children"
                            onChange={(val) => setBrandId(val)}
                            onSearch={brandSearchDebounce}
                            filterOption={() => {
                              return true;
                            }}
                            mode="multiple"
                            options={brandOptions?.list}
                          ></Select>
                        </Form.Item>
                        <div className="buttons-container mt-3">
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="add-submit-btn text-center mr-2"
                          >
                            Submit
                          </Button>
                          <Button
                            type="ghost"
                            htmlType="button"
                            onClick={() => form?.resetFields()}
                            className="reset-submit-btn text-center mr-2"
                          >
                            Reset
                          </Button>
                        </div>
                      </Form>
                    </Modal>
                  </div>

                  <PaginationTwo
                    {...brandData?.data}
                    limit={limit}
                    page={getPage(loc.search)}
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      </ShopLayout>
    </React.Fragment>
  );
};

export default HubBrandList;
